import { OrderDocument } from 'orders-rest';
import { NSIInstructionExecutor, UserBean, NsiRestService, NSIInstructionStatus, NSIThematicHeading, NSIInstructionPriority, NSIInstructionDifficulty } from 'oasi-nsi-rest';
import { InstructionExecutor } from '../models/InstructionExecutor';
import * as _ from 'lodash';
import { NewOrderModel } from '../models/NewOrderModel';
import { LoadingStatus } from 'oasi-widgets';
import { IFileInFolderInfo, IFolderInfo } from 'isogd-file-rest';

export class СancellController {
    result: string = 'Отменено';
    static $inject = ['$uibModalInstance'];
    constructor(private $uibModalInstance: angular.ui.bootstrap.IModalServiceInstance) {
    }

    ok() {
        this.$uibModalInstance.close(this.result);
    }

    cancel() {
        this.$uibModalInstance.dismiss('cancel');
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/cancel/cancel.ts